import { type JSX, splitProps } from "solid-js";

/**
 * Figma tam/text-field: label Medium 13 #49454f, 6 px gap, 54 px white box, 1 px #666665 border,
 * radius 4, shadow 0 1 2 rgba(0,0,0,.12), padding 16, value Regular 16 (Figma 15: iOS Safari zooms on inputs under 16 px). Extra props go to <input>.
 */
export function TextField(
  props: JSX.InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    label: string;
    inputClass?: string;
  },
) {
  const [local, rest] = splitProps(props, ["label", "class", "inputClass"]);
  return (
    <div class={`flex flex-col gap-[6px] ${local.class ?? ""}`}>
      <label
        for={rest.id}
        class="text-[13px] font-medium leading-[1.25] tracking-[0.13px] text-strong"
      >
        {local.label}
      </label>
      <input
        {...rest}
        class={`h-[54px] w-full rounded-[4px] border border-text bg-white px-4 text-base leading-[1.25] tracking-[0.15px] text-strong shadow-[0_1px_2px_rgba(0,0,0,0.12)] outline-none placeholder:text-text/70 focus:border-violet focus:shadow-[0_0_0_1px_#6d3e91] read-only:focus:border-text read-only:focus:shadow-[0_1px_2px_rgba(0,0,0,0.12)] ${local.inputClass ?? ""}`}
      />
    </div>
  );
}

/** Shared text styles of the sign-in screens: Figma G0b (e-mail, code) and the phone check. */
/** G0b prompt: Medium 19, #49454f, centred. */
export const AUTH_HEADING =
  "px-[5px] text-center text-[19px] font-medium leading-[1.25] tracking-[0.19px] text-strong";
/** Body under the prompt: Regular 15, #666665, centred. */
export const AUTH_TEXT =
  "mt-2 px-[5px] text-center text-[15px] leading-[1.25] tracking-[0.15px] text-text";
/** Links (#1e90ff, underlined, Regular 14). */
export const AUTH_LINK =
  "py-1 text-sm leading-[1.25] text-link underline disabled:text-text disabled:no-underline";
export const AUTH_ERROR = "mt-3 text-sm leading-[1.25] text-[#e53935]";
